import { ExternalLink, EllipsisVertical } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@/components/ui/dropdown-menu';
import { providerUrlSlugs } from 'src/shared/entities';
import { Button } from '@/components/ui/button';
import {
  IntegrationConnectionToggle,
  UpdateCredentialsCustomIntegration,
  type IActiveIntegrationProps,
} from 'src/containers/Integrations';

const IntegrationDropdownMenu = ({
  id,
  provider,
  __typename: type,
}: Pick<IActiveIntegrationProps['integration'], 'id' | 'provider' | '__typename'>) => {
  const onMoreInfoClick = () => {
    const path = providerUrlSlugs[provider as keyof typeof providerUrlSlugs];

    window.open(`https://codekeeper.co/integrations/${path}`, '_blank');
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="h-8 w-8 shrink-0">
          <EllipsisVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="end" className="w-max">
        <UpdateCredentialsCustomIntegration id={id} __typename={type} />
        <DropdownMenuItem className="py-2 cursor-pointer" onClick={onMoreInfoClick}>
          <ExternalLink />
          Learn more
        </DropdownMenuItem>
        <IntegrationConnectionToggle id={id} __typename={type} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default IntegrationDropdownMenu;
